import PropTypes from "prop-types"

const AppletSelectorContent = ({
  serviceName,
  contentAppletName,
  contentAppletIcon,
}) => {
  return (
    <div>
      {contentAppletName ? (
        <img src={contentAppletIcon} alt={contentAppletName} />
      ) : (
        <div>
          Choose an Applet to see how {serviceName} is integrating with other
          services.
        </div>
      )}
    </div>
  )
}

AppletSelectorContent.propTypes = {
  serviceName: PropTypes.string.isRequired,
  contentAppletName: PropTypes.string,
  contentAppletColor: PropTypes.string,
  contentAppletIcon: PropTypes.string,
}

export default AppletSelectorContent
